<form [formGroup]="form">
  <p-autoComplete
    (completeMethod)="searchOznakeNaziv($event)"
    (onClear)="clearInput()"
    (onSelect)="onSelectChange($event)"
    [(ngModel)]="kategorijaModel"
    [appendTo]="shouldAppendToBody ? 'body' : undefined"
    [dropdown]="true"
    [ngClass]="!kategorijaModel && formSubmitted ? 'test-invalid' : ''"
    [suggestions]="kategorijeSuggestions"
    field="naziv"
    formControlName="naziv"
    inputStyleClass="input-el"
    panelStyleClass="ko-autocomplete"
    placeholder="Naziv sadržaja..."
  >
  </p-autoComplete>

  <small *ngIf="!kategorijaModel && formSubmitted" class="p-invalid">{{
      errorMsg
    }}</small>
</form>
